module.exports = __webpack_public_path__ + "img/grid-sample8.98e54503.jpg";